import { useFormik } from "formik";
import * as Yup from 'yup';
import { ProyectoColaboradorDTO } from "../../interfaces/ProyectosDTOS/ProyectoColaboradorDTO";
import { Alert, Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import CatalogService from "../../services/CatalogService";
import { IndexacionDTO } from "../../interfaces/IndexacionDTO";
import { useEffect, useState } from "react";
import { Unidad } from "../../interfaces/Unidad";
import { FaRegAddressCard } from "react-icons/fa";
import { Modal as ModalStrap, ModalBody, TabContent, TabPane, ModalHeader, NavItem, Nav, NavLink, Table } from "reactstrap";
import { AiOutlinePlusCircle, AiOutlineSearch } from "react-icons/ai";
import { ProyectoColaboradoreDTO } from "../../interfaces/ProyectoColaboradoreDTO";
import ProyectoService from "../../services/ProyectoService";

const catalogoService = new CatalogService();
const proyectoService = new ProyectoService();

interface Props {
    idproy: number,
    token: any,
    personal: ProyectoColaboradorDTO;
    onResponse?: (dataRespuesta: any) => void
}

export const FormColaborador: React.FC<Props> = ({ idproy, personal, token, onResponse }) => {
    const [tap, setTap] = useState(0);
    const [roles, setRoles] = useState<Array<IndexacionDTO>>([]);
    const [unidades, setUnidades] = useState<Array<Unidad>>([]);
    let [busquedaUsuario, setBusquedaUsuario] = useState<Array<ProyectoColaboradoreDTO>>([])
    let [userModal, setUserModal] = useState(false);
    let [loadingModal, setLoadingModal] = useState(false);
    let [mailBusqueda, setMailBusqueda] = useState('');
    let [apellidosBusqueda, setApellidosBusqueda] = useState('');

    const colaboradorSchema = Yup.object().shape({
        // cedula: Yup.string().required('La cedula es requerida').matches(/^\d{10}$/, 'La cédula debe tener 10 dígitos'),
        // nombre: Yup.string().required('Nombres son requeridos'),
        // email: Yup.string().email('Correo no válido').required('Correo es requerido'),
        // idunidad: Yup.string().notOneOf([''], 'No puede ser ninguno').required('Rol es requerido'),
        iddecinvrolinvestigador: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
        escolabproyecto: Yup.string().notOneOf(['0'], 'No puede ser ninguno').required('Rol es requerido'),
    });

    const formik = useFormik<ProyectoColaboradorDTO>({
        initialValues: {
            ...personal,
            iddecinvproyecto: idproy,
        },
        validationSchema: colaboradorSchema,
        onSubmit: (values) => {
            console.log(values);
            if (values.iddecinvproyectocolaboradores > 0) {
                Actualizar(values);
            } else {
                Guardar(values);
            }
        }
    });



    const Guardar = async (obj: ProyectoColaboradorDTO) => {
        await proyectoService.PostNuevoColaboradorDTO(obj, token)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    if (onResponse) {
                        onResponse(data.data);
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            });
    }

    const Actualizar = async (obj: ProyectoColaboradorDTO) => {
        await proyectoService.PutColaboradorDTO(obj, token)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    if (onResponse) {
                        onResponse(data.data);
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            });
    }

    const handleOpenUserModal = () => {
        setUserModal(true)
    };
    const toggleModal = () => {
        setUserModal(!userModal);
    };

    const unidadesData = async () => {
        await catalogoService.obtenerCatalogoUnidades()
            .then((data) => setUnidades(data.objDatos))
            .catch((error) => console.error(error))
    }

    const fetchData = async () => {
        try {
            await catalogoService.GetRolInvestigadorActivo()
                .then((data) => {
                    console.log(data)
                    if (data.status.isSuccessfully) {
                        setRoles(data.listData);
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    function setListBusqueda(apellidos: string, email: string) {
        setLoadingModal(true);
        proyectoService.GetDatosPersonalesColaborador(apellidos, email, token)
            .then((data) => {
                //console.log(data.objDatos);
                if (data.listData === null) {
                    setBusquedaUsuario([]);
                    setLoadingModal(false);
                } else {
                    setBusquedaUsuario(data.listData);
                    setLoadingModal(false);
                }
            })
            .catch((error) => {
                console.error(error)
                setBusquedaUsuario([]);
                setLoadingModal(false);
            });
    }

    const handleEmailBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        //console.log(value);
        setMailBusqueda(value);
    }
    const handleEmailBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // Acciones a realizar cuando el campo de entrada pierde el foco
        //console.log('Campo perdió el foco. Valor actual:', mailBusqueda);
    };
    const handleApellidosBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Actualizar el estado
        if (value !== apellidosBusqueda) {
            setApellidosBusqueda(value);
        }
    }

    const buttonStyle = {
        marginTop: '10px', // Ajusta el valor de acuerdo a tu preferencia
    };

    const tabStyle = {
        cursor: 'pointer', // Cambia el cursor a "pointer" cuando se pasa sobre el botón
    };

    useEffect(() => {
        fetchData();
        unidadesData();
    }, []);

    return (
        <form onSubmit={formik.handleSubmit}>
            {/* <Grid item sx={{ m: 1 }} xs={12} sm={6} md={3} lg={3}>
                <Button aria-label="addEspol" variant="contained" color="info" onClick={handleOpenUserModal} endIcon={<FaRegAddressCard />} >
                    Personal Espol
                </Button>
            </Grid>*/}
            <br /> 
            <Grid container direction={'row'} spacing={1}>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.cedula && formik.touched.cedula)}>
                        <TextField
                            id="cedula"
                            type="text"
                            name="cedula"
                            label="CI"
                            value={formik.values.cedula}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            sx={{ marginBottom: '20px', width: '100%' }}
                            InputLabelProps={{
                                shrink: true, // Asegura que el label no se superponga al valor
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        {formik.touched.cedula && formik.errors.cedula && (
                            <Alert severity="error">{formik.errors.cedula}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.email && formik.touched.email)}>
                        <TextField
                            id="email"
                            type="text"
                            name="email"
                            label="Email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            sx={{ marginBottom: '20px', width: '100%' }}
                            InputLabelProps={{
                                shrink: true, // Asegura que el label no se superponga al valor
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        {formik.touched.email && formik.errors.email && (
                            <Alert severity="error">{formik.errors.email}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.nombre && formik.touched.nombre)}>
                        <TextField
                            id="nombre"
                            type="text"
                            name="nombre"
                            label="Nombre"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            sx={{ marginBottom: '20px', width: '100%' }}
                            InputLabelProps={{
                                shrink: true, // Asegura que el label no se superponga al valor
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        {formik.touched.nombre && formik.errors.nombre && (
                            <Alert severity="error">{formik.errors.nombre}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.iddecinvrolinvestigador && formik.touched.iddecinvrolinvestigador)}>
                        <InputLabel htmlFor="select-rol">Rol</InputLabel>
                        <Select
                            labelId="select-rol"
                            id="iddecinvrolinvestigador"
                            name="iddecinvrolinvestigador"
                            value={formik.values.iddecinvrolinvestigador}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="Rol"
                            sx={{ marginBottom: '20px', width: '100%' }}
                        >
                            {roles.map((a) => (
                                <MenuItem key={a.codigo} value={a.codigo}>
                                    {a.descripcion}
                                </MenuItem>
                            ))
                            }
                            <MenuItem value={0}>Seleccione un Rol</MenuItem>
                        </Select>
                        {formik.touched.iddecinvrolinvestigador && formik.errors.iddecinvrolinvestigador && (
                            <Alert severity="error">{formik.errors.iddecinvrolinvestigador}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.escolabproyecto && formik.touched.escolabproyecto)}>
                        <InputLabel htmlFor="select-escolab">Es colaborador del Proyecto</InputLabel>
                        <Select
                            labelId="select-escolab"
                            id="escolabproyecto"
                            name="escolabproyecto"
                            value={formik.values.escolabproyecto}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="Es colaborador del Proyecto"
                            sx={{ marginBottom: '20px', width: '100%' }}
                        >
                            <MenuItem value={0}>Seleccione...</MenuItem>
                            <MenuItem value={1}>Si</MenuItem>
                            <MenuItem value={2}>No</MenuItem>
                        </Select>
                        {formik.touched.escolabproyecto && formik.errors.escolabproyecto && (
                            <Alert severity="error">{formik.errors.escolabproyecto}</Alert>
                        )}
                    </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.tipocolaborador && formik.touched.tipocolaborador)}>
                        <InputLabel htmlFor="select-escolab">Tipo Colaborador</InputLabel>
                        <Select
                            labelId="select-escolab"
                            id="tipocolaborador"
                            name="tipocolaborador"
                            value={formik.values.tipocolaborador}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="Tipo Colaborador"
                            sx={{ marginBottom: '20px', width: '100%' }}
                        >
                            <MenuItem value={0}>Seleccione...</MenuItem>
                            <MenuItem value={1}>Espol</MenuItem>
                            <MenuItem value={2}>Externo</MenuItem>
                        </Select>
                        {formik.touched.tipocolaborador && formik.errors.tipocolaborador && (
                            <Alert severity="error">{formik.errors.tipocolaborador}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.idunidad && formik.touched.idunidad)}>
                        <InputLabel htmlFor="select-unidad">Unidad</InputLabel>
                        <Select
                            labelId="select-unidad"
                            id="idunidad"
                            name="idunidad"
                            value={formik.values.idunidad}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="Unidad"
                            sx={{ marginBottom: '20px', width: '100%' }}
                        >
                            {unidades.map((a) => (
                                <MenuItem key={a.idunidad} value={a.idunidad}>
                                    {a.nombreunidad}
                                </MenuItem>
                            ))
                            }
                            <MenuItem value={0}>Seleccione una unidad</MenuItem>
                        </Select>
                        {formik.touched.idunidad && formik.errors.idunidad && (
                            <Alert severity="error">{formik.errors.idunidad}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.fechaingresoproyecto && formik.touched.fechaingresoproyecto)}>
                        <TextField
                            id="fechaingresoproyecto"
                            type="date"
                            name="fechaingresoproyecto"
                            label="Fecha Ingreso"
                            value={formik.values.fechaingresoproyecto}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            sx={{ marginBottom: '20px', width: '100%' }}

                            InputLabelProps={{
                                shrink: true, // Asegura que el label no se superponga al valor
                            }}
                        />
                        {formik.touched.fechaingresoproyecto && formik.errors.fechaingresoproyecto && (
                            <Alert severity="error">{formik.errors.fechaingresoproyecto}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth error={Boolean(formik.errors.fechasalidaproyecto && formik.touched.fechasalidaproyecto)}>
                        <TextField
                            id="fechasalidaproyecto"
                            type="date"
                            name="fechasalidaproyecto"
                            label="Fecha Salida"
                            value={formik.values.fechasalidaproyecto}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            sx={{ marginBottom: '20px', width: '100%' }}

                            InputLabelProps={{
                                shrink: true, // Asegura que el label no se superponga al valor
                            }}
                        />
                        {formik.touched.fechasalidaproyecto && formik.errors.fechasalidaproyecto && (
                            <Alert severity="error">{formik.errors.fechasalidaproyecto}</Alert>
                        )}
                    </FormControl>
                </Grid> */}
                <Grid item xs={12} sm={12} md={12}>
                    <Button
                        style={{ width: '50%', borderRadius: '25px' }}
                        variant="contained"
                        type="submit"  // Cambiar de 'submit' a 'button'
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
            <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal">
                <ModalHeader toggle={toggleModal}>
                    <Typography id="modal-modal-title" >Busqueda Usuario</Typography>
                </ModalHeader>
                <ModalBody>
                    <Nav tabs>
                        <NavItem>
                            <NavLink className={tap === 0 ? 'active' : ''} style={tabStyle}
                                onClick={() => setTap(0)}
                            >
                                Email
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={tap === 1 ? 'active' : ''} style={tabStyle}
                                onClick={() => setTap(1)}
                            >
                                Apellidos
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={tap}>
                        <TabPane tabId={0}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={9} lg={9}>
                                    <TextField
                                        id='busq-email'
                                        type="email"
                                        name='mailBusqueda'
                                        label="Email"
                                        sx={{ m: 1, width: '100%' }}
                                        size="small"
                                        value={mailBusqueda}
                                        onChange={handleEmailBusquedaChange}
                                        onBlur={handleEmailBlur}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda('N', mailBusqueda) }}>Buscar</Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    {loadingModal ?
                                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                            <CircularProgress color="success" />
                                        </Stack> :
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell>Cedula</TableCell>
                                                    <TableCell>Apellidos y Nombres</TableCell>
                                                    <TableCell>Correo</TableCell>
                                                    <TableCell>Accion</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {busquedaUsuario.map((colaborador, index) => (
                                                    <TableRow key={'colProy-' + index}>
                                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                        <TableCell>
                                                            {colaborador.cedula}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.nombre}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.email}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton aria-label="add" color="info" onClick={() => console.log(colaborador)}>
                                                                <AiOutlinePlusCircle />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                {busquedaUsuario.length == 0 ?
                                                    <TableRow key={'colProy-o'}>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell>Sin resultados</TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow> : <></>
                                                }
                                            </TableBody>
                                        </Table>
                                    }
                                </Grid>
                            </Grid>
                        </TabPane>
                        <TabPane tabId={1}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={9} lg={9}>
                                    <TextField
                                        id='busq-apellidos'
                                        label="Apellidos"
                                        sx={{ m: 1, width: '100%' }}
                                        size="small"
                                        value={apellidosBusqueda}
                                        onChange={handleApellidosBusquedaChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda(apellidosBusqueda, 'N') }}>Buscar</Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    {loadingModal ?
                                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                            <CircularProgress color="success" />
                                        </Stack> :
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell>Cedula</TableCell>
                                                    <TableCell>Apellidos y Nombres</TableCell>
                                                    <TableCell>Correo</TableCell>
                                                    <TableCell>Accion</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {busquedaUsuario.map((colaborador, index) => (
                                                    <TableRow key={'colProy-' + index}>
                                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                        <TableCell>
                                                            {colaborador.cedula}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.nombre}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.email}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton aria-label="add" color="info" onClick={() => console.log(colaborador)}>
                                                                <AiOutlinePlusCircle />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                {busquedaUsuario.length == 0 ?
                                                    <TableRow key={'colProy-o'}>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell>Sin resultados</TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow> : <></>
                                                }
                                            </TableBody>
                                        </Table>
                                    }
                                </Grid>
                            </Grid>
                        </TabPane>
                    </TabContent>
                </ModalBody>
            </ModalStrap>
        </form>
    );
}